import * as React from 'react';

import { rem } from '../../tokens/spacing';

/* ─────────────────────────── Types ──────────────────────────────────────── */

export type AppShellVariant = 'default' | 'minimal' | 'dashboard';

export interface AppShellContextValue {
  navbarHeight: string;
  sidebarWidth: string;
  sidebarCollapsed: boolean;
  variant: AppShellVariant;
}

/* ─────────────────────────── Context ────────────────────────────────────── */

const DEFAULT_CONTEXT: AppShellContextValue = {
  navbarHeight: rem(67),
  sidebarWidth: '0px',
  sidebarCollapsed: false,
  variant: 'default',
};

const AppShellContext = React.createContext<AppShellContextValue | null>(null);

/* ─────────────────────────── Provider ───────────────────────────────────── */

export interface AppShellProviderProps {
  value: AppShellContextValue;
  children: React.ReactNode;
}

export function AppShellProvider({ value, children }: AppShellProviderProps): JSX.Element {
  return <AppShellContext.Provider value={value}>{children}</AppShellContext.Provider>;
}

AppShellProvider.displayName = 'AppShellProvider';

/* ─────────────────────────── Hook ───────────────────────────────────────── */

export function useAppShell(): AppShellContextValue {
  const ctx = React.useContext(AppShellContext);
  if (ctx == null) {
    return DEFAULT_CONTEXT;
  }
  return ctx;
}
